// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';
// 👇 --- IMPORTACIONES DE STRIPE ---
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import './index.css'; // 👈 Asegúrate que importa Tailwind

// --- Opcional: MUI Theme (Comentado si ya no lo usas) ---
/*
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
const theme = createTheme({ ... });
*/

// --- Leer Claves API ---
const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY; // Clave publica Stripe

// ----> AÑADE ESTA LÍNEA <----
console.log('Intentando leer REACT_APP_STRIPE_PUBLISHABLE_KEY:', stripePublishableKey);
// ----> FIN LÍNEA AÑADIDA <----
console.log('Variable de prueba:', process.env.REACT_APP_TEST_VAR);
// --- Validar Claves (Opcional pero recomendado) ---
if (!googleClientId) {
  console.error("ERROR FATAL: REACT_APP_GOOGLE_CLIENT_ID no está definido en el archivo .env del frontend.");
  // Podrías mostrar un error permanente en lugar de la app
}
if (!stripePublishableKey) {
  console.error("ERROR: REACT_APP_STRIPE_PUBLISHABLE_KEY no está definido en .env. La funcionalidad de pago no estará disponible.");
  // La app seguirá funcionando, pero Stripe no se cargará.
}

// --- Cargar Stripe ---
// Carga Stripe fuera del render para evitar recrearlo.
// Solo intenta cargar si la clave existe.
const stripePromise = stripePublishableKey ? loadStripe(stripePublishableKey) : null;

// --- Crear el Root de React ---
const root = ReactDOM.createRoot(document.getElementById('root'));

// --- Renderizar la Aplicación ---
root.render(
  <React.StrictMode>
    {/* Proveedor para Google Login */}
    {/* Asegurarse que googleClientId no sea undefined antes de pasarlo */}
    {googleClientId ? (
      <GoogleOAuthProvider clientId={googleClientId}>
        {/* Proveedor para Stripe */}
        {/* Renderiza Elements solo si stripePromise se cargó (si la clave existía) */}
        {stripePromise ? (
          <Elements stripe={stripePromise}>
            {/* 👇 Aquí va tu App principal */}
            <App />
          </Elements>
        ) : (
          <>
            {/* Mensaje si falta la clave de Stripe O renderiza la App sin pagos */}
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, background: 'red', color: 'white', padding: '5px', textAlign: 'center', zIndex: 9999 }}>
              Advertencia: Clave publicable de Stripe no encontrada. Los pagos están deshabilitados.
            </div>
            <App /> {/* Renderiza la App igualmente pero sin <Elements> */}
          </>
        )}
      </GoogleOAuthProvider>
    ) : (
       // Mensaje si falta la clave de Google
       <div style={{ padding: '20px', color: 'red', textAlign: 'center' }}>
         Error: Falta la configuración del Cliente ID de Google (REACT_APP_GOOGLE_CLIENT_ID). La aplicación no puede iniciarse correctamente.
       </div>
    )}
  </React.StrictMode>
);